import { Directive, ElementRef, HostListener } from '@angular/core';

import { ResponseErrorService } from '../../modules/errors/response-error.service';
import { EIconPath } from '../../shared/enums/icons.enum';

@Directive({
    selector: '[ppImage]',
    standalone: false
})
export class ImagesFallbackDirective {
  defaultPath = EIconPath.PLACEHOLDER_IMAGE;
  public _element: HTMLImageElement;

  constructor(
    private elementRef: ElementRef,
    private responseErrorService: ResponseErrorService,
  ) {
    this._element = this.elementRef.nativeElement;
  }

  @HostListener('error', ['$event'])
  onError(): void {
    this.responseErrorService.errors(500);
    this._element.src = this.defaultPath;
  }
}
